/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-25 17:44:33
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-04-26 16:25:19
 * @FilePath: /seller-station-client/src/container/Root.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { NestedRoute } from '@sniff/routeguard';
import { Layout } from 'antd';
import VipDialogComponent from '@/common/vip/Index';
import useInitGetUserInfo from '@/hooks/useInitGetUserInfo';
import Header from '@/common/layout/header';

export default () => {
	useInitGetUserInfo();
	return (
		<Layout style={{ minHeight: '100vh' }} className="w-[100%]">
			<Header />
			<VipDialogComponent />
			<NestedRoute />
		</Layout>
	);
};
